module.exports = __webpack_public_path__ + "static/media/figuretext-2.70ad4c02.png";